import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/jira': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M490 241.7C417.1 169 320.6 71.8 248.5 0 83 164.9 6 241.7 6 241.7-1.9 249.6-1.9 262.4 6 270.4 138.8 402.7 67.8 331.9 248.5 512 627.9 134 264.2 495.3 490 270.3 498 262.4 498 249.6 490 241.7zM248.5 331.7L172.5 256 248.5 180.3 324.5 256 248.5 331.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/jira.js
// module id = +KnM
// module chunks = 144